import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ZoomInIcon(props: IconProps) {
    return <Icon {...props} iconKey={"zoom_in"}/>
}
